import { render } from "./SectionPwa.vue?vue&type=template&id=4247c451&scoped=true"
import script from "./SectionPwa.vue?vue&type=script&lang=js"
export * from "./SectionPwa.vue?vue&type=script&lang=js"

import "./SectionPwa.vue?vue&type=style&index=0&id=4247c451&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4247c451"]])

export default __exports__